import React from 'react';
import PropTypes from 'prop-types';

const progress = props => (
  <div className="progress-bar">
    {/* <div className="progress-bar_inner" style={{ width: `${props.size}%` }} /> */}
    <div className={['dot green', (props.step === 'activity') && 'active'].join(' ')} />
    <div className={['dot purple', (props.step === 'loseWeight') && 'active'].join(' ')} />
    <div className={['dot red', (props.step === 'smoking') && 'active'].join(' ')} />
    <div className={['dot yellow', (props.step === 'alcohol') && 'active'].join(' ')} />
  </div>
);

progress.propTypes = {
  // size: PropTypes.string.isRequired,
  step: PropTypes.oneOf(['activity', 'loseWeight', 'smoking', 'alcohol', 'all']).isRequired,
};

export default progress;



// WEBPACK FOOTER //
// ./src/Components/Progress/index.jsx